export default __webpack_public_path__ + "static/media/capa-3.ec804936.png";